<template>
    <div class="borrowDetailsBox">
        <Box title="可疑医疗器械不良事件报告">

            <div class="borrow box">
                <p class="title">基本信息</p>
                <Field title="报告日期" type="calendar" placeholder='请输入' :text="data.BG_DATE"
                    @onMessage="value => data.BG_DATE = value" />
                <Field title='报告科室' type='manufacturer' name='departmentList' placeholder='请选择' :text='data.BG_KSS'
                    @manuconfirm='data.BG_KS=arguments[0].a,data.BG_KSS=arguments[0].b' />
                <Field title="报告人" type="text" :text="data.TBRMC" />
                <Field title='报告来源' type='manufacturer' name='BLSJ_BGLY' placeholder='请选择' :text='data.BG_LYMC'
                    @manuconfirm='data.BG_LY=arguments[0].a,data.BG_LYMC=arguments[0].b' />

                <Field title='报告人职业' type='manufacturer' name='BLSJ_BGRZY' placeholder='请选择' :text='data.BG_CZRMC'
                    @manuconfirm='data.BG_CZR=arguments[0].a,data.BG_CZRMC=arguments[0].b' />
            </div>
            <div class="box">
                <p class="title">患者信息</p>
                <Field title="姓名" type="input" placeholder='请输入' :text="data.PAT_NAME"
                    @onMessage="value => data.PAT_NAME = value" />
                <Field title="出生日期" type="calendar" placeholder='请输入' :text="data.BG_ZRRQ"
                    @onMessage="value => data.BG_ZRRQ = value" />
                <Field title="性别" :tabSelected="data.PAT_SEX" type="teb" :data="[{id:'1',name:'男'},{id:'2',name:'女'}]"
                    @onMessage="data.PAT_SEX=arguments[0].id" />
                <Field title="年龄" type="input" placeholder='请输入' :text="data.PAT_AGE"
                    @onMessage="value=>data.PAT_AGE=value" />
                <Field title="病案号" type="input" placeholder='请输入' :text="data.BG_DWYB"
                    @onMessage="value => data.BG_DWYB = value" />
                <Field title="既往病史" type="textarea" placeholder='请输入' :text="data.PAT_DISEASE"
                    @onMessage="value => data.PAT_DISEASE = value" />
            </div>
            <div class="box">
                <p class="title">使用情況</p>
                <Field title="发生时间" type="calendar" placeholder='请输入' :text="data.EVENT_OCCUR_DATE"
                    @onMessage="value => data.EVENT_OCCUR_DATE = value" />
                <Field title="发现或知悉时间" type="calendar" placeholder='请输入' :text="data.BG_FXRQ"
                    @onMessage="value => data.BG_FXRQ = value" />

                <Field title='伤害' type='manufacturer' name='BLSJ_EventResult' placeholder='请选择'
                    :text='data.EVENT_RESULTMC'
                    @manuconfirm='data.EVENT_RESULT=arguments[0].a,data.EVENT_RESULTMC=arguments[0].b' />
                <Field title="器械使用日期" type="calendar" placeholder='请输入' :text="data.BG_TYRQ"
                    @onMessage="value => data.BG_TYRQ = value" />

                <Field title='使用场所' type='manufacturer' name='BLSJ_SYCS' placeholder='请选择' :text='data.BG_DWLXDZMC'
                    @manuconfirm='data.BG_DWLXDZ=arguments[0].a,data.BG_DWLXDZMC=arguments[0].b' />

                <Field title="伤害表现" type="textarea" placeholder='请输入' :text="data.BG_DWMC"
                    @onMessage="value => data.BG_DWMC = value" />
                <Field title="预期治疗疾病或作用" type="textarea" placeholder='请输入' :text="data.BG_DWLXDH"
                    @onMessage="value => data.BG_DWLXDH = value" />
                <Field title="事件陈述" type="textarea" placeholder='请输入' :text="data.EVENT_DESCRIBE"
                    @onMessage="value => data.EVENT_DESCRIBE = value" />
            </div>
            <div class="box">
                <p class="title">医疗器械情况</p>

                <Field title='报告状态' type='manufacturer' name='BLSJ_BGZT' placeholder='请选择' :text='data.SB_EVENT_STATUSS'
                    @manuconfirm='data.SB_EVENT_STATUS=arguments[0].a,data.SB_EVENT_STATUSS=arguments[0].b' />

                <Field title='设备名称' :action='true' type='manufacturer' placeholder='请选择'
                    name='EquipmentDictionariesNoText' :text='data.SBMC' @manuconfirm='ValueChange(arguments[0])' />

                <Field title="注册证号" type="input" placeholder='请输入' :text='data.BG_ZCZJH'
                    @onMessage="value => data.BG_ZCZJH = value" />
                <Field title="产品编号" type="input" placeholder='请输入' :text='data.BG_CPBH'
                    @onMessage="value => data.BG_CPBH = value" />
                <Field title="产品批号" type="input" placeholder='请输入' :text='data.BG_CPPH'
                    @onMessage="value => data.BG_CPPH = value" />
                <Field title="规格型号" type="input" placeholder='请输入' :text='data.BG_SB_GGXH'
                    @onMessage="value => data.BG_SB_GGXH = value" />

                <Field title="生产企业" type="manufacturer" name="supplier" placeholder='请选择' :text="data.BG_SB_SCQYMC"
                    @manuconfirm="data.BG_SB_SCQY=arguments[0].a,data.BG_SB_SCQYMC=arguments[0].b" />

                <Field title="有效日期" type="calendar" :DateMax='DateMax' placeholder='请输入' :text="data.BG_YXQ"
                    @onMessage="value => data.BG_YXQ = value" />
                <Field title="生产日期" type="calendar" placeholder='请输入' :text="data.BG_SCRQ"
                    @onMessage="value => data.BG_SCRQ = value" />
                <Field title="器械故障表现" type="textarea" placeholder='请输入' :text="data.SB_EVENT_REASON"
                    @onMessage="value => data.SB_EVENT_REASON = value" />
            </div>
            <div class="box">
                <p class="title">医疗器械情况</p>

                <Field title='事件原因分析' type='manufacturer' name='BLSJ_YYFX' placeholder='请选择'
                    :text='data.AnalysisCauses1'
                    @manuconfirm='data.BG_SPMC=arguments[0].a,data.AnalysisCauses1=arguments[0].b' />

                <Field title="事件原因分析描述" type="textarea" placeholder='请输入' :text='data.BG_SJJCPJYJ'
                    @onMessage="value => data.BG_SJJCPJYJ = value" />
                <Field title="事件初步处理情况" type="textarea" placeholder='请输入' :text='data.BG_GJJCPJYJ'
                    @onMessage="value => data.BG_GJJCPJYJ = value" />
            </div>
        </Box>
        <div class="footer">
            <div class="button" @click="save" v-if="$route.params.isShow">保存</div>
        </div>
    </div>
</template>

<script>
    import Footer from '../../components/footer/footer'
    import Box from '../../components/commonBox/commonBox'
    import Field from '../../components/field/field.vue'
    export default {
        name: 'addAdverseEvent',
        components: {
            Box,
            Field,
            Footer
        },
        data() {
            return {
                DateMax: new Date(new Date().getFullYear() + 10, '01', '01'),
                data: this.$route.params.item ? { //Equipemnt信息
                } : {

                }
            }
        },
        mounted() {
            this.$route.params.item ? this.loadDataDefault() : '';
        },
        methods: {
            loadDataDefault() {
                this.$get('api/AdverseEvent/GetAderseEventDetail', {
                    BG_ID: this.$route.params.item.BG_ID
                }).then(result => {
                    console.log(result);
                    // result = JSON.parse(result);
                    this.data = result.DetailModel;
                });
            },
            //提交
            save() {
                this.$post('api/AdverseEvent/AddOrEditAdverseEvent', {
                    data: JSON.stringify(this.data),
                    GKHM: this.$UserInfo.UserId,
                    GKMC: this.$UserInfo.UserName,
                    LX: "2",
                    KS: this.$UserInfo.DepartmentId,
                    KSMC: this.$UserInfo.DepartmentName
                }).then(result => {
                    if (result.Status) {
                        this.$Toast("保存成功!");
                        this.$router.back();
                    } else {
                        this.$Toast("保存失败!");
                    }
                });
            },
            ValueChange(obj) {
                this.data.SB_BH = obj.a; //设备编号
                this.data.BG_SB_GGXH = obj.c; //设备型号
                this.data.BG_CPBH = obj.m; //产品编号
            }
        }
    }
</script>

<style scoped lang="scss">
    .borrowDetailsBox {
        padding-bottom: 120px;
    }

    .box {
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 34px 40px 0;
        box-sizing: border-box;
        margin-bottom: 20px;
    }

    .title {
        color: $TEXT-DARK-COLOR;
        font-size: 34px;
        font-weight: bold;
    }

    .equipment {
        height: 424px;

        img {
            width: 150px;
            height: 150px;
        }

        .equipment-details {
            display: flex;
            margin-top: 24px;

            &>div {
                margin-left: 34px;
                display: flex;

                div {
                    &:first-child {
                        color: #999;
                        line-height: 55px;
                    }

                    &:last-child {
                        color: #333;
                        line-height: 55px;

                        p {
                            width: 280px;
                            font-size: 29px;
                            color: #333;
                        }
                    }
                }
            }
        }

        &>div:last-child {
            display: flex;
            border-top: 2px solid #F3F3F3;
            margin-top: 20px;

            div {
                flex: 1;
                text-align: left;
                height: 66px;
                line-height: 66px;
                font-size: 29px;
                color: #999;

                &:first-child {
                    border-right: 2px solid #F3F3F3;
                }
            }
        }
    }

    .accessories {
        .title {
            margin-bottom: 10px;
        }

        .check-box {
            display: flex;
            height: 112px;
            border-bottom: 2px solid #F3F3F3;

            .van-checkbox {
                flex: 1;
            }

            span {
                margin-top: 30px;
            }
        }

        .check-box1 {
            .van-checkbox {
                width: 60px;
            }
        }

    }

    .explain {
        input {
            width: 100%;
            text-align: left;
            margin: 20px 0 48px;
        }
    }

    input {
        width: 150px;
        font-size: 29px;
        text-align: center;
        color: #858585;

        &::-webkit-input-placeholder {
            color: #858585;
        }
    }

    .footer {
        position: fixed;
        bottom: 0;
        width: 100%;
        height: 114px;
        background: $BACKGROUND-COLOR;
        box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.16);
        padding-top: 24px;

        .button {
            width: 690px;
            height: 96px;
            background: $THEME-COLOR;
            border-radius: 8px;
            color: $TEXT-LIGHT-COLOR;
            font-size: 30px;
            text-align: center;
            line-height: 96px;
            margin: auto;
        }
    }

    .borrowHelper {
        float: right;
        color: #666666;
        height: 50px;

        span {
            position: absolute;
            top: 0px;
            right: 38px;
            bottom: 0px;
        }

        img {
            width: 40px;
            height: 40px;
        }
    }

    .JFBZ {
        color: #969799;
        text-align: left;
    }

    .FYBZTitle {
        background: #4FA69E;
        height: 70px;
        text-align: left;

        span {
            color: #FFFFFF;
            margin-left: 25px;
        }

        p {
            font-size: 12px;
            color: #FFFFFF;
            text-indent: 2em;
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/adverseEvent/addAdverseEvent.vue